import { useCallback, useMemo, useRef } from 'react';

import type { ToastContextState, ToastAppearance } from '../contexts/ToastContext';
import { ToastContext } from '../contexts/ToastContext';

interface ToastProviderProps {
  children: React.ReactNode;
}

export const ToastProvider = ({ children }: ToastProviderProps) => {
  const toastRootElement = useRef<HTMLDivElement | null>(null);

  const showToast = useCallback((message: string, type: ToastAppearance) => {
    if (toastRootElement.current) {
      toastRootElement.current.innerHTML = `
        <mc-toast position="top-right" appearance="${type}" open>
          <mc-notification appearance="${type}">
            ${message}
          </mc-notification>
        </mc-toast>
      `;
    }
  }, []);

  const contextValue: ToastContextState = useMemo(() => ({ showToast }), [showToast]);

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <div ref={toastRootElement} id="toast-root" />
    </ToastContext.Provider>
  );
};
